import { useTranslation } from 'react-i18next';
import { EditLog, type EditLogEntry } from '../../documents/EditLog';

interface PolicyEditLogProps {
    editLog: EditLogEntry[];
    hidePreviewOnMobile?: boolean;
}

const ACTION_LABEL_KEYS: Record<string, string> = {
    created: 'departmentPolicies.editLog.created',
    edited: 'departmentPolicies.editLog.edited',
    completed: 'departmentPolicies.editLog.completed',
    deleted: 'departmentPolicies.editLog.deleted',
    variables_changed: 'departmentPolicies.editLog.variablesChanged',
    approved: 'departmentPolicies.editLog.approved',
    approval_removed: 'departmentPolicies.editLog.approvalRemoved',
};

const DOT_COLORS: Record<string, string> = {
    approved: 'bg-emerald-500',
    approval_removed: 'bg-amber-500',
};

export function PolicyEditLog({
    editLog,
    hidePreviewOnMobile = false,
}: PolicyEditLogProps) {
    const { t } = useTranslation();

    const translatedLabels = Object.fromEntries(
        Object.entries(ACTION_LABEL_KEYS).map(([action, key]) => [action, t(key)])
    );

    return (
        <EditLog
            editLog={editLog}
            hidePreviewOnMobile={hidePreviewOnMobile}
            title={t('departmentPolicies.editLog.history')}
            actionLabels={translatedLabels}
            dotColors={DOT_COLORS}
            showMoreLabel={(count) => t('departmentPolicies.editLog.showMore', { count })}
            hideLabel={t('departmentPolicies.editLog.hide')}
        />
    );
}
